// Import network logos
const ArbitrumSvg = 'https://developers.iexchange.global/images/network-logos/arbitrum.svg';
const BaseSvg = 'https://developers.iexchange.global/images/network-logos/base.svg';
const BscSvg = 'https://developers.iexchange.global/images/network-logos/bsc.svg';
const CeloPng = 'https://developers.iexchange.global/images/network-logos/celo.png';
const HederaPng = 'https://developers.iexchange.global/images/network-logos/hedera.png';
const InkJpg = 'https://developers.iexchange.global/images/network-logos/ink.jpg';
const KakarotPng = 'https://developers.iexchange.global/images/network-logos/kakarot.png';
const LiskPng = 'https://developers.iexchange.global/images/network-logos/lisk.png';
const MantlePng = 'https://developers.iexchange.global/images/network-logos/mantle.png';
const MorphSvg = 'https://developers.iexchange.global/images/network-logos/morph.svg';
const OptimismPng = 'https://developers.iexchange.global/images/network-logos/optimism.png';
const ScrollSvg = 'https://developers.iexchange.global/images/network-logos/scroll.svg';
const UnichainPng = 'https://developers.iexchange.global/images/network-logos/unichain.png';
const DefaultNetworkPng = 'https://developers.iexchange.global/images/network-logos/network.png';

// const t= logos
const EthSvg = 'https://developers.iexchange.global/images/token-logos/eth.svg';
const UsdcSvg = 'https://developers.iexchange.global/images/token-logos/usdc.svg';
const UsdtSvg = 'https://developers.iexchange.global/images/token-logos/usdt.svg';

// Map keys to icon data-URI strings
export const networkIconMap: Record<string, string> = {
  arbitrum: ArbitrumSvg,
  base: BaseSvg,
  bsc: BscSvg,
  binance: BscSvg,
  bnb: BscSvg,
  celo: CeloPng,
  hedera: HederaPng,
  ink: InkJpg,
  kakarot: KakarotPng,
  lisk: LiskPng,
  mantle: MantlePng,
  morph: MorphSvg,
  optimism: OptimismPng,
  scroll: ScrollSvg,
  unichain: UnichainPng,
};

export const tokenIconMap: Record<string, string> = {
  eth: EthSvg,
  usdc: UsdcSvg,
  usdt: UsdtSvg,
  // tokens that reuse network icons
  bnb: BscSvg,
  mnt: MantlePng,
};

/**
 * Returns a base-64 data URI for a given network name.
 * Performs a loose substring match so "Arbitrum One" still resolves.
 */
export function getNetworkIconUrl(networkName: string): string {
  const lower = networkName.toLowerCase();
  for (const key of Object.keys(networkIconMap)) {
    if (lower.includes(key)) return networkIconMap[key];
  }
  return DefaultNetworkPng; // fallback generic icon
}

/**
 * Returns a base-64 data URI for a given token symbol/name.
 * Falls back to matching network icons and then ETH icon.
 */
export function getTokenIconUrl(tokenName: string): string {
  const lower = tokenName.toLowerCase();
  for (const key of Object.keys(tokenIconMap)) {
    if (lower.includes(key)) return tokenIconMap[key];
  }

  // Fallback: try network icons
  const networkUrl = getNetworkIconUrl(tokenName);
  if (networkUrl !== DefaultNetworkPng) return networkUrl;

  return EthSvg; // generic token icon
}
